import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCurrentInternalUser } from '../lib/currentUser';
import Sidebar from '../components/Sidebar';
import OttoGallery from '../components/otto/OttoGallery';

// Dev-only Otto showcase as a standalone page (route /dev/otto), so the
// full pose set + interaction triggers (flying/send, award airshow, intro
// card, seasonal accessories) can be browsed live without the test-env flag
// that gates the Dashboard-embedded copy. Internal users only.
export default function OttoGalleryPage() {
  const navigate = useNavigate();
  const { user: currentInternalUser } = useCurrentInternalUser();

  return (
    <div className="min-h-screen bg-canvas flex">
      <Sidebar currentInternalUser={currentInternalUser} />
      <div className="flex-1 flex flex-col min-w-0">
        <div className="pt-8">
          <div className="px-8 mb-2 flex items-start justify-between gap-6">
            <div>
              <p className="font-['Metropolis'] text-[10px] font-bold tracking-[2px] uppercase text-fusion-forest mb-1.5">Dev · Otto</p>
              <h1 className="font-['Metropolis'] text-3xl font-bold text-ink leading-tight">Otto gallery</h1>
              <p className="font-['Metropolis'] text-sm text-fusion-mid-grey mt-2 max-w-[70ch]">
                Every pose in both wardrobes, at hero / empty-state / chip sizes, plus live triggers — the send-brief flight and the award airshow are the flying Otto. Purely a QA surface.
              </p>
            </div>
            <button
              type="button"
              onClick={() => navigate('/dashboard')}
              className="flex-shrink-0 mt-1 font-['Metropolis'] text-xs font-semibold tracking-[1px] uppercase text-fusion-mid-grey border border-line rounded-full px-4 py-2 hover:border-active-green hover:text-active-green transition-colors">
              Back to dashboard
            </button>
          </div>
          <div className="mx-8 h-px bg-[#E6E9DA]" aria-hidden="true" />
        </div>
        <div className="px-8 pb-16">
          <OttoGallery defaultOpen />
        </div>
      </div>
    </div>
  );
}
